export async function aiSearch({ queryContent, query, location }) {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

  const normalizedQueryContent = Array.isArray(queryContent)
    ? queryContent
    : query?.trim()
      ? [{ role: 'user', content: query.trim() }]
      : [];

  if (!normalizedQueryContent.length) {
    throw new Error('query_content is required for AI search');
  }

  const payload = {
    query_content: normalizedQueryContent,
    location: location || null,
  };

  const response = await fetch(`${BACKEND_URL}/ai/search`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${AUTH_TOKEN}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const responseBody = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(responseBody.message || 'AI search request failed');
  }

  return responseBody;
}
